<div class="widget-container" [ngClass]="{ smallScreen: isSmallScreen }" (click)="focusWidget(selectedIndex)" data-cy="calender-widget">
  <widget-title
    [sectionButtons]="{ seeAll: (items || isLoading) && !error }"
    [movedWidget]="movedWidget"
    [isSmallScreen]="isSmallScreen"
    (navigate)="navigate()"
  >
    <section class="widget-title-content">
      <u-button
        class="today-button"
        label="Today"
        type="secondary"
        [styles]="{ width: '70px', height: '28px' }"
        (onClick)="onClickToday()"
        [pTooltip]="currentDate.toDate() | date"
        tooltipPosition="top"
        tooltipStyleClass="u-tooltip"
        [disabled]="disabled"
      >
      </u-button>
      <div class="arrow-buttons">
        <u-icon
          [ngClass]="{ disabled: isToday }"
          [model]="{ type: 'font', value: 'icon-arrow-left-key' }"
          (click)="onClickPrevDay()"
          pTooltip="Previous day"
          tooltipPosition="top"
          tooltipStyleClass="u-tooltip"
          [disabled]="disabled"
        ></u-icon>
        <u-icon
          [ngClass]="{ disabledButton: disabled }"
          [model]="{ type: 'font', value: 'icon-arrow-right-key' }"
          (click)="onClickNextDay()"
          pTooltip="Next day"
          tooltipPosition="top"
          tooltipStyleClass="u-tooltip"
          [disabled]="disabled"
        ></u-icon>
        <h1 class="date">{{ currentDate.toDate() | date: (isSmallScreen ? 'MMM d' : 'MMM d, yyyy') }}</h1>
      </div>
    </section>
  </widget-title>

  <div class="main" *ngIf="!noConnectApps">
    <h1 class="title" #calendarTitle [style.display]="items?.length || isLoading ? 'block' : 'none'">Upcoming Meetings</h1>
    <!--data-->
    <smooth-height [trigger]="items">
      <section *ngIf="!isLoading && items && amountOfCurrentItems > 0" [style.height.px]="heightWidget - WIDGET_HEADER">
        <ng-scrollbar visibility="hover">
          <cdk-virtual-scroll-viewport appendOnly itemSize="67" ngScrollbarView smoothScroll scrollViewport [class.virtual-scroll]="true">
            <section>
              <ul class="events-list">
                <calendar-widget-item
                  #resultItem
                  *ngFor="let item of items; index as i"
                  [model]="item"
                  class="result-item"
                  [isSmallScreen]="isSmallScreen"
                  [searchInfo]="searchInfo"
                  [pageNameForTelemetry]="pageNameForTelemetry"
                  [selected]="selectedIndex === i && isFocused"
                  [class.selected]="selectedIndex === i && isFocused"
                  [index]="i"
                  [soonEvent]="soonEvent"
                  (click)="updateSelectedIndex(i)"
                  (mouseover)="keyboardOn = false"
                >
                </calendar-widget-item>
              </ul>
            </section>
          </cdk-virtual-scroll-viewport>
        </ng-scrollbar>
      </section>
    </smooth-height>

    <div *ngIf="!isLoading && !amountOfCurrentItems && items && !noConnectApps" class="no-result-container body">
      <widget-no-result
        class="no-results"
        mainTitle="Upcoming Meetings"
        title="You’re off the hook!"
        subtitle="No upcoming meeting or events scheduled"
        [imgModel]="{
          lightUrl: 'calendar-empty-state',
          darkUrl: 'calendar-empty-state-dark',
        }"
      >
      </widget-no-result>
    </div>

    <!--loading-->
    <ng-container *ngIf="isLoading">
      <result-ghost *ngFor="let i of 20 | fill"></result-ghost>
    </ng-container>

    <!--error-->
    <div class="widget-body center" *ngIf="error && !items">
      <div class="error-container center">
        <h1 class="error-title">ERROR</h1>
        <span class="error-subtitle">
          Your boards can’t be shown right now.<br />
          Try refreshing this page or start over if that doesn’t do the trick.
        </span>
        <u-button label="Try Again" type="primary" (onClick)="tryAgain()">
          <u-icon [styles]="{ fontSize: '14px', marginRight: '8px' }"></u-icon>
        </u-button>
      </div>
    </div>
  </div>

  <!--connect-->
  <div class="connect center" *ngIf="!isLoading && !error && noConnectApps">
    <u-icon
      class="no-results-img"
      [model]="{
        type: 'img',
        value: {
          lightUrl: '/assets/bar/widgets/calendar-connect.svg',
          darkUrl: '/assets/bar/widgets/calendar-connect-dark.svg',
        },
      }"
    ></u-icon>
    <span class="connect-title">Upcoming meetings</span>
    <div class="connect-subtitle"><span>Connect your calendar now to know what’s next</span></div>
    <u-button class="connect-button" (onClick)="connect()" [label]="'Connect now'"></u-button>
  </div>
</div>
